<template>
    <operation-auth-dialog
        v-if="visible"
        :open="visible"
        :agent-name="agentName"
        :loading="loading"
        :reject-loading="rejectLoading"
        @agree="handleAgree"
        @reject="handleReject"
        @dismiss="handleDismiss"
    />
</template>

<script>
import OperationAuthDialog from './operation-auth-dialog.vue';

export default {
    name: 'OperationAuthConfirm',
    components: {
        'operation-auth-dialog': OperationAuthDialog
    },
    data() {
        return {
            visible: false,
            loading: false,
            rejectLoading: false,
            fid: '',
            agentName: ''
        };
    },
    mounted() {
        this.check();
    },
    methods: {
        check() {
            this.$http.get('/bp/api/lawyer/trustee/current').then(res => {
                if (res && +res.code === 0) {
                    const list = res.data.list || [];
                    const target = list.find(o => Number(o.status) === 2 && o.should_popup && o.fid);
                    if (target) {
                        this.fid = target.fid;
                        this.agentName = target.agent_name || '';
                        this.visible = true;
                    }
                }
            }).catch(() => {});
        },
        submitConfirm(agree) {
            if (this.loading || this.rejectLoading) {
                return;
            }
            // 授权与拒绝各自维护 loading
            const key = agree === 1 ? 'loading' : 'rejectLoading';
            this[key] = true;
            this.$http.post('/bp/api/lawyer/trustee/confirm', {
                fid: this.fid,
                agree
            }).then(res => {
                if (res && +res.code === 0) {
                    this.visible = false;
                    if (agree === 1) {
                        this.$Message.success('已授权托管');
                    }
                    return;
                }
                this.$Message.error(res && res.msg || '操作失败，请重试');
            }).catch(() => {
                this.$Message.error('操作失败，请重试');
            }).finally(() => {
                this[key] = false;
            });
        },
        // 授权托管
        handleAgree() {
            this.submitConfirm(1);
        },
        // 拒绝托管
        handleReject() {
            this.submitConfirm(0);
        },
        // 关闭（标记已展示，当前不再自动弹）
        handleDismiss() {
            this.visible = false;
            if (this.fid) {
                this.$http.post(
                    '/bp/api/lawyer/trustee/popup_shown', {
                        fid: this.fid
                    }).catch(() => {});
            }
        }
    }
};
</script>
